export default "__VITE_ASSET__2d9db459__"